// extracted by mini-css-extract-plugin
module.exports = {"gene-select-wrapper":"GeneSelect_gene-select-wrapper__2rXPu"};